import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import { connect } from 'react-redux';
import secureStorage from '../config/encrypt';
//Custom component
import PrivateRoute from './privateRoute';
import Header from './../view/common/Header';
import Footer from './../view/common/Footer';
import Login from './../view/login/component/login';
import AddStock from './../view/inventory/component/add-stock';
import ManageStock from './../view/inventory/component/manage-stock';
import Dashboard from '../view/dashboard/dashboard';
import BuyerLead from '../view/enquiry/component/BuyerEnquiry';
import AddbuyerEnquires from '../view/enquiry/component/AddbuyerEnquires';
import AdminRoute from './routeAdmin'
import EditListing from './../view/dealer/component/EditListing';
import DealerSubscriptionPannel from '../view/subscription/DealerSubscriptionPannel';
import SkuTransactionPannel from '../view/skusTransactions/SkuTransactionPannel';
// import MyAccount from './../view/dealerpages/MyAccount';//need to remove
import AdminDealerList from './../view/dealer/component/dealer-list-foradmin';
import ForgotPassword from './../view/login/component/ForgotPassword';
import ResetPassword from './../view/login/component/ResetPassword';
import ChangePassword from './../view/login/component/ChangePassword';
import Logout from './../view/common/logout';
// import NotFound from './../view/common/NotFound';//need to remove
import SalesSupportAccount from '../view/salesSupportUsers/SalesSupportAccount';

/* dealer detail */
import DealerDetail from './../view/dealerDetail/component/MyAccount';
import RemoveInfo from './../view/login/component/remove-info'
import LeadList from '../view/if-application/lead/LeadList';
import IFDashboard from '../view/if-application/dashboard/Dashboard';
import IFApplicationDetails from '../view/if-application/details/IFApplicationDetails';
import HomeSurveyList from '../view/if-application/details/HomeSurveyList';
import SfaChat from '../view/if-application/sfa-chat/SfaChat';
import '../if-dealer.scss';
class CustomRouter extends Component {
    constructor(props) {
        super(props);
        this.state = {ht:500}
    }
    componentDidMount(){
        this.setState({
            ht : window.innerHeight - 127
        });
        window.addEventListener('resize', () => {
            this.setState({
                ht : window.innerHeight - 127
            });
        }, false);

        // Restore login state from local storage
        const userInfo = secureStorage.getItem('loginUserInfo');
        if (userInfo) {
            this.props.dispatch({ type: 'LOGIN_USER', componentState: userInfo });
        }
    }
    render() {
        const isLoggedIn = this.props.user_loggedin;
        return (
            <Router>
                {isLoggedIn === 1 ? <Header /> : ''}
                <div  style={{minHeight: this.state.ht}}>
                <Route path="/" exact component={Login} />
                <Route path="/login" component={Login} />
                <Route path="/forgot" component={ForgotPassword} />
                <Route path="/reset-password" component={ResetPassword} />
                <Route path="/change-password" component={ChangePassword} />
                <Route exact path={`/dealer-subscriptions`} component={DealerSubscriptionPannel} />
                <Route path="/dealer-transactions" component={SkuTransactionPannel} />
                <Route path="/dashboard" component={Dashboard} />
                <Route path="/add-stock" exact component={AddStock} />
                <Route path="/add-stock/:used_car_stock_id" component={AddStock} />
                <Route path="/manage-stock" component={ManageStock} />
                <Route path="/add-truck" exact component={AddStock} />
                <Route path="/add-truck/:used_car_stock_id" component={AddStock} />
                <Route path="/manage-truck" component={ManageStock} />
                <PrivateRoute exact path="/add-lead" component={AddbuyerEnquires} />
                <PrivateRoute exact path="/lead/:car_id_hash?" component={BuyerLead} />
                <Route path="/edit-dealer-list" component={EditListing} />
                <Route path="/my-account" component={DealerDetail} />
                <Route path="/admin-dealer-list" component={AdminDealerList} />
                <Route path="/dealer/:dealer_id_hash" component={DealerDetail} />
                <Route path="/sales-user/:id" component={SalesSupportAccount} />
                <Route path="/logout" component={Logout} />
                <Route path="/admin" component={AdminRoute} />
                <Route path="/remove-info" component={RemoveInfo}/>
                <div className='if-applications'>
                    <Route path="/if-application/sfa-chat" component={SfaChat} />
                    <Route path="/if-application/lead-list" component={LeadList} />
                    <Route path="/if-application/home-survey-list" component={HomeSurveyList} />
                    <Route path="/if-application/dashboard" component={IFDashboard} />
                    <Route path="/if-application-detail/:application_id" component={IFApplicationDetails} />
                </div>
                </div>
                {isLoggedIn === 1 ? <Footer /> : ''}
            </Router>
        );
    }
}

const mapStateToProps = state => {
    return {
        user_loggedin: state.userLoggedIn
    };
}
export default connect(mapStateToProps, null)(CustomRouter);
